import React, { useState } from 'react';
import { TextField, Typography, Box } from '@mui/material';

const ExtraUser = ({ initialValue, onChange, disabled }) => {
  const [value, setValue] = useState(initialValue);
  if (initialValue !== value) setValue(initialValue);
  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue === '' || (parseInt(newValue) >= 0 && parseInt(newValue) <= 200)) {
      setValue(newValue);
      onChange(newValue === '' ? '' : parseInt(newValue)); // Pass the new value back to the parent component
    }
  };

  const isError = !disabled && (parseInt(value) < 1 || parseInt(value) > 200 || value === '');

  return (
    <div>
      <Box
       
       
       
       
        sx={{ color: isError ? undefined : '#717171', p: 2, border: isError ? '1px solid red' : 1, borderColor: 'grey.500', borderRadius: 2 }}>
        <Typography gutterBottom>Extra Percentage</Typography>
        <TextField
          type="number"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          fullWidth
          variant="outlined"
          margin="dense"
         
         slotProps={{htmlInput: { min: 1, max: 200 }}}/>
      </Box>
    </div>
  );
};

export default ExtraUser;
